export interface CoreAzureContainerAppsModuleConfiguration {
    id: string

    subscriptionId?: string

    resourceGroupName?: string

    jobName?: string

    targetEnvironmentId?: string

    sourceEnvironment?: string

    tenantId?: string
}

export const emptyGuid = '00000000-0000-0000-0000-000000000000';

const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const isGuid = (value?: string): boolean =>
    !!value && value !== emptyGuid && guidPattern.test(value);

export const invalidNameCharacters = ['/', '\\', '?', '#', '%', ' '];

export const hasInvalidNameCharacter = (value?: string): boolean =>
    !!value && invalidNameCharacters.some(c => value.includes(c));
